import React, { useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'; // Import arrow icon
import Box from '@mui/material/Box';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import left arrow icon
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import right arrow icon


function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(null);
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null); // State for dropdown menu

  const navigate = useNavigate();
  const location = useLocation();

  const handleMobileMenuToggle = (event) => {
    setMobileMenuOpen(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(null);
  };

  const handleDropdownOpen = (event) => {
    setDropdownAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setDropdownAnchorEl(null);
  };

  const handleNavigation = (section) => {
    if (location === 'home') {
      navigate('/'); // Always navigate to the home page
    } else if (location.pathname === '/gallery' || location.pathname === '/job-offer' || location.pathname === '/statics-lng') {
      navigate('/'); // Navigate to the home page first
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'gold', color: 'black' }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <img src="/img/lngpng.png" alt="Logo" style={{ height: '60px' }} />
        </Typography>

        {/* Desktop Menu */}
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Button color="inherit" onClick={() => handleNavigation('home')}>Accueil</Button>
          <Button color="inherit" onClick={() => handleNavigation('about')}>À Propos</Button>
          <Button color="inherit" onClick={() => handleNavigation('services')}>Service</Button>
          <Button color="inherit" onClick={() => handleNavigation('contact-us')}>Contact</Button>
          <Button
            color="inherit"
            endIcon={<ArrowDropDownIcon />} // Add dropdown arrow
            onClick={handleDropdownOpen} // Open dropdown menu
          >
            Publication
          </Button>
          <Menu
            anchorEl={dropdownAnchorEl}
            open={Boolean(dropdownAnchorEl)}
            onClose={handleDropdownClose}
          >
            <MenuItem onClick={() => { handleDropdownClose(); navigate('/job-offer'); }}>Offre D'Emploi</MenuItem>
            <MenuItem onClick={() => { handleDropdownClose(); navigate('/statics-lng'); }}>Statistique LNG</MenuItem>
          </Menu>
          <Button color="inherit">
            <RouterLink to="/gallery" style={{ color: 'inherit', textDecoration: 'none' }}>Galerie</RouterLink>
          </Button>
        </Box>

        {/* Mobile Menu */}
        {/* Mobile Menu */}
<Box sx={{ display: { xs: 'flex', md: 'none' } }}>
  <IconButton
    size="large"
    edge="start"
    color="inherit"
    aria-label="menu"
    onClick={handleMobileMenuToggle}
  >
    <MenuIcon />
  </IconButton>
  <Menu
    anchorEl={mobileMenuOpen}
    open={Boolean(mobileMenuOpen)}
    onClose={handleMobileMenuClose}
  >
    <MenuItem onClick={() => { handleMobileMenuClose(); handleNavigation('home'); }}>Accueil</MenuItem>
    <MenuItem onClick={() => { handleMobileMenuClose(); handleNavigation('about'); }}>À Propos</MenuItem>
    <MenuItem onClick={() => { handleMobileMenuClose(); handleNavigation('services'); }}>Service</MenuItem>
    <MenuItem onClick={() => { handleMobileMenuClose(); handleNavigation('contact-us'); }}>Contact</MenuItem>
    <MenuItem
      onClick={handleDropdownOpen} // Open the submenu
      sx={{ display: 'flex', justifyContent: 'space-between' }}
    >
      Publication <ArrowDropDownIcon />
    </MenuItem>
    <Menu
      anchorEl={dropdownAnchorEl}
      open={Boolean(dropdownAnchorEl)}
      onClose={handleDropdownClose}
    >
      <MenuItem onClick={handleDropdownClose}>
  <RouterLink to="/job-offer" style={{ color: 'inherit', textDecoration: 'none' }}>
    Offre D'Emploi
  </RouterLink>
</MenuItem>
<MenuItem onClick={handleDropdownClose}>
  <RouterLink to="/statics-lng" style={{ color: 'inherit', textDecoration: 'none' }}>
    Statistique LNG
  </RouterLink>
</MenuItem>
    </Menu>
    <MenuItem onClick={handleMobileMenuClose}>
      <RouterLink to="/gallery" style={{ color: 'inherit', textDecoration: 'none' }}>Galerie</RouterLink>
    </MenuItem>
  </Menu>
</Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;